var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 19.5588,
    fill: "#D0D5DD",
    stroke: "#F8F9FC",
    strokeWidth: 1.11765
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_589_4062",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 38,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4412 21C39.4412 31.1848 31.1848 39.4412 21 39.4412C10.8152 39.4412 2.55882 31.1848 2.55882 21C2.55882 10.8152 10.8152 2.55882 21 2.55882C31.1848 2.55882 39.4412 10.8152 39.4412 21Z",
    fill: "#9A9A9A",
    stroke: "#C3C9D2",
    strokeWidth: 1.11765
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_589_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9983 25.0714C25.4955 25.0714 29.1412 21.4257 29.1412 16.9285C29.1412 12.4313 25.4955 8.78564 20.9983 8.78564C16.5011 8.78564 12.8555 12.4313 12.8555 16.9285C12.8555 21.4257 16.5011 25.0714 20.9983 25.0714Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9994 26.4285C14.2568 26.436 8.79266 31.9001 8.78516 38.6428C8.78516 39.3923 9.39275 39.9999 10.1423 39.9999H31.8565C32.6061 39.9999 33.2137 39.3923 33.2137 38.6428C33.2062 31.9001 27.7421 26.4359 20.9994 26.4285Z",
    fill: "#667085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e4ea595128046c0226c5884770cf9e36.svg";
export { ForwardRef as ReactComponent };